"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitch = void 0;
var _react = _interopRequireDefault(require("react"));
var Twitch = exports.Twitch = function Twitch() {
  return _react["default"].createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    filter: "url(#filter0_d)"
  }, _react["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "36",
    height: "36",
    rx: "2",
    fill: "#9146FF"
  }), _react["default"].createElement("path", {
    d: "M31.6897 23.1429L26.5172 28.2857H21.3448L16.819 32.7857V28.2857H11V9H31.6897V23.1429Z",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M27.8108 13.5H25.2246V21.2143H27.8108V13.5Z",
    fill: "#9146FF"
  }), _react["default"].createElement("path", {
    d: "M20.6975 13.5H18.1113V21.2143H20.6975V13.5Z",
    fill: "#9146FF"
  })), _react["default"].createElement("defs", null, _react["default"].createElement("filter", {
    id: "filter0_d",
    x: "0",
    y: "0",
    width: "40",
    height: "40",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _react["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), _react["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), _react["default"].createElement("feOffset", {
    dx: "-1",
    dy: "-1"
  }), _react["default"].createElement("feGaussianBlur", {
    stdDeviation: "1"
  }), _react["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.129412 0 0 0 0 0.188235 0 0 0 0.33 0"
  }), _react["default"].createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), _react["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))));
};